var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsSharing = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.515 8.045a2.507 2.507 0 1 0-2.43-1.888L8.384 10.51a2.507 2.507 0 1 0-.062 3.328l6.702 4.353a2.507 2.507 0 1 0 .434-1.149l-6.557-4.258a2.5 2.5 0 0 0 .024-1.194l6.73-4.37a2.5 2.5 0 0 0 1.86.826Zm0-1.2a1.307 1.307 0 1 0 0-2.615 1.307 1.307 0 0 0 0 2.615m-11.037 6.6a1.307 1.307 0 1 0 0-2.614 1.307 1.307 0 0 0 0 2.614m12.345 5.03a1.307 1.307 0 1 1-2.615 0 1.307 1.307 0 0 1 2.615 0",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsSharing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights-sharing.cca7be53.svg";